module.exports = "<p>\n  {{'LOGOUT.LOGOUT_CONFIRMATION' | translate}}\n\n  <button (click)=\"onLogout($event)\">{{'LOGOUT.LOGOUT' | translate}}</button>\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/auth/logout/logout.component.html
// module id = 1DO0
// module chunks = 0